import { render, staticRenderFns } from "./CheckUserHistory.vue?vue&type=template&id=e21f8ac4&scoped=true"
import script from "./CheckUserHistory.vue?vue&type=script&lang=js"
export * from "./CheckUserHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21f8ac4",
  null
  
)

export default component.exports